import './CountBadge.scss';
import classNames from 'classnames';
import { prefixClass } from 'lib/utils';

interface CountBadgeProps {
  /** The count to display */
  count: number;
  /** Optional size variant */
  size?: 'small' | 'medium';
  /** Additional class name */
  className?: string;
}

/**
 * CountBadge - Displays a numeric count in a circular badge
 */
const CountBadge = ({ count, size = 'medium', className }: CountBadgeProps) => {
  const prefix = prefixClass('q2-count-badge');

  return (
    <div className={classNames(prefix(), size, className)}>
      <span className={prefix('value')}>{count}</span>
    </div>
  );
};

export default CountBadge;
